import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Player,
} from 'video-react';


import './style.scss';

export default class VideoPlayer extends PureComponent {
   static propTypes = {
      children: PropTypes.any,
      fluid: PropTypes.bool,
      muted: PropTypes.bool,
      play: PropTypes.bool,
      controls: PropTypes.bool,
      width: PropTypes.number,
      height: PropTypes.number,
      poster: PropTypes.string,
      src: PropTypes.string,
      preload: PropTypes.any,
      aspectRatio: PropTypes.string,
      autoPlay: PropTypes.bool,
      startTime: PropTypes.number,
      getSeekTime: PropTypes.func,
      loop: PropTypes.bool,
      onError: PropTypes.func,
      onErrorStateChange: PropTypes.func,
      onPause: PropTypes.func,
      onPlay: PropTypes.func,
   };

   static defaultProps = {
      onPause: () => console.log('onPause'),
      onPlay: () => console.log('onPlay'),
   };

   constructor(props) {
      super(props);

      this.state = {
         player: {},
      };
      this.retryCount = 0;
   }


   componentDidMount() {
      this.player.subscribeToStateChange(this.handleStateChange.bind(this));
      const { play } = this.props;
      if(play !== null) {
         this.playOrPause(play);
      }
   }

   componentDidUpdate(prevProps, prevState, snapshot) { //eslint-disable-line
      const { play: prevPlay } = prevProps;
      const { play: currentPlay, onErrorStateChange } = this.props;
      const { player: { paused: statePaused, error } } = this.state;
      const { player: { paused: prevPaused, currentTime } } = prevState;
      const { getSeekTime } = this.props;

      if(currentPlay !== null && currentPlay !== prevPlay) {
         this.playOrPause(currentPlay);
      }

      if(statePaused && !prevPaused && getSeekTime && currentTime) { // TODO temporary solution
         getSeekTime(currentTime);
      }

      if(error && onErrorStateChange) {
         if(typeof error === 'object' && error.code && error.code === 3) {
            // disable autoplay
         } else if(error === 'UNKNOWN ERROR') {
            this.retry();
         } else {
            onErrorStateChange();
         }
      }
   }

   static getDerivedStateFromProps(nextProps, prevState) {
      const { play: nextPlay } = nextProps;
      const { player: { paused: statePaused } } = prevState;
      if(nextPlay === statePaused) {
         return null;
      }

      return nextProps;
   }

   componentWillUnmount() {
   }

   /**
    * if we do not know the cause of the breakdown, we will repeatedly request video resource,
    * set a limit to not get into an infinite loop
    */
   retry = () => {
      if(this.retryCount >= 50) {
         return;
      }
      this.player.load();
      this.retryCount = this.retryCount + 1;
   };

   onClick = () => {
   };

   playOrPause = (_bool) => {
      const { player } = this.player.getState();
      try {
         if(_bool) {
            this.play();
         } else if(!player.paused) {
            this.pause();
         }
      } catch (e) {
         if(this.player && player.readyState >= 2) {
            if(_bool) {
               this.player.muted = true;
               this.play();
            } else {
               this.pause();
            }
         }
      }
   };

   play = () => {
      this.player.play();
   };

   pause = () => {
      this.player.pause();
   };

   handleStateChange(state, prevState) { // eslint-disable-line
      const { onPause, onPlay } = this.props;
      // most expensive method (performance)
      this.setState(() => ({
         player: state,
      }));
      const { paused } = state;
      if(paused) {
         onPause();
      } else {
         onPlay();
      }
   }

   render() {
      const {
         children,
         ...rest
      } = this.props;
      return (
         <Player
            ref={ ref => this.player = ref }
            playsInline={ true }
            { ...rest }
         >
            { children }
         </Player>
      );
   }
}
